import React, { useRef } from "react";
import RCSCardLog from "./RCSCardLog";
import { useVirtualizer } from "@tanstack/react-virtual";
import PropTypes from "prop-types";

const RCSCardsLog = ({ data }) => {
  const parentRef = useRef(null);

  const rowVirtualizer = useVirtualizer({
    count: data.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 180,
    overscan: 5,
  });

  return (
    <div
      ref={parentRef}
      style={{
        height: "100%",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          height: `${rowVirtualizer.getTotalSize()}px`,
          width: "100%",
          position: "relative",
        }}
      >
        {rowVirtualizer.getVirtualItems().map((virtualRow) => {
          const item = data[virtualRow.index];
          return (
            <div
              key={`${virtualRow.index}-${item.uid_transaction}`}
              ref={rowVirtualizer.measureElement}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                transform: `translateY(${virtualRow.start}px)`,
              }}
            >
              <RCSCardLog data={item} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

RCSCardsLog.propTypes = {
  data: PropTypes.array,
};

export default RCSCardsLog;